/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import { Transaction, TransactionPrintPageData, warranties } from 'src/types';
import { ViewWarrantyRow } from './ViewWarranty';
import { TextBoldWarranty, TextRegularWarranty } from './TextWarranty';
import { cloneDeep } from 'lodash';
import { ProductTypeEnum } from 'src/enums';
import { RenderCurrency } from './RenderCurrency';
import { computeNetOfVat, computeVatAmount, computeWithholdingTax } from 'src/utils';

interface Props {
  totalTransactionAmount?: number;
  isTwoThreeOSeven?: boolean;
  isVATExempted?: boolean;
}

const styles = StyleSheet.create({
  main: {
    position: 'absolute',
    bottom: 75,
    right: 20,
  },
  computationsContainer: {
    marginTop: 4,
    justifyContent: 'flex-end'
  },
});

export const RenderVatComputation = ({
  totalTransactionAmount = 0,
  isTwoThreeOSeven,
  isVATExempted = false
}: Props) => {
  
  const computationObj = useMemo(() => {
    const totalSalesVatInclusive = totalTransactionAmount;
    const lessVat = computeVatAmount(totalTransactionAmount);
    const amountNetOfVat = computeNetOfVat(totalTransactionAmount);
    const lessWithholdingTax = isVATExempted
      ? 0
      : isTwoThreeOSeven
      ? computeWithholdingTax(totalTransactionAmount)
      : 0;
    const totalAmountDue = isVATExempted
      ? amountNetOfVat
      : totalSalesVatInclusive - lessWithholdingTax;

    return {
      totalSalesVatInclusive,
      lessVat,
      amountNetOfVat,
      lessDiscountSCPwdNaacMovIsp: 0,
      addVat: 0,
      lessWithholdingTax,
      totalAmountDue,
      vatableSales: isVATExempted ? 0 : amountNetOfVat,
      vat: isVATExempted ? 0 : lessVat,
      zeroRatedSales: isVATExempted ? amountNetOfVat : 0,
      vatExemptSales: 0
    };

  }, [totalTransactionAmount, isTwoThreeOSeven, isVATExempted])

  return (
    <View style={styles.main}>
      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.totalSalesVatInclusive} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.lessVat} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.amountNetOfVat} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.lessDiscountSCPwdNaacMovIsp} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.addVat} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.lessWithholdingTax} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.totalAmountDue} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.vatableSales} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.vat} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.zeroRatedSales} /></TextBoldWarranty> 
      </ViewWarrantyRow>

      <ViewWarrantyRow style={styles.computationsContainer}>
        <TextBoldWarranty><RenderCurrency amount={computationObj?.vatExemptSales} /></TextBoldWarranty> 
      </ViewWarrantyRow>

    </View>
  );
};
